import type { SVGProps } from 'react'

/**
 * Agent — 8-point compass star, single 16-vertex polygon.
 *
 * Outer points reach ±124 from center (only ~4px padding inside the
 * 256x256 viewBox) so the star fills more of its tile and reads at
 * the same visual size as peer logos like Ask, Tasker, etc. Cusps at
 * radius 28 keep the arms slim (the "compass star" identity); raising
 * outer extent rather than fattening cusps was the intentional choice
 * — see the "Match logo visual weight" note in `packages/ui/AGENTS.md`.
 *
 * currentColor-driven, 256x256 viewBox.
 */
export function AgentLogo(props: SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" fill="currentColor" {...props}>
      <path d="M128,4 L139,102 L216,40 L154,117 L252,128 L154,139 L216,216 L139,154 L128,252 L117,154 L40,216 L102,139 L4,128 L102,117 L40,40 L117,102 Z" />
    </svg>
  )
}
